import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { StoreProvider } from './contexts/StoreContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { CompareBar } from './components/CompareBar';
import { VirtualAssistant } from './components/assistant/VirtualAssistant';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { VehicleDetail } from './pages/VehicleDetail';
import { Simulator } from './pages/Simulator';
import { CreditCheck } from './pages/CreditCheck';
import { Compare } from './pages/Compare';
import { Brands } from './pages/Brands';
import { BrandDetail } from './pages/BrandDetail';
import { Admin } from './pages/Admin';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
interface AppProps {
  /** Muestra las unidades de ejemplo junto a las de la planilla hasta que se cargue el inventario real. */
  showExampleVehicles?: boolean;
}
export function App({
  showExampleVehicles = true
}: AppProps) {
  return <StoreProvider showExamples={showExampleVehicles} data-id="element-0" data-mp="3rdaselgk8ijp">
      <BrowserRouter data-id="element-1" data-mp="5yjetptzbev">
        <ScrollToTop data-id="element-2" data-mp="6hq1ea16ddl" />
        <div className="flex min-h-screen w-full flex-col bg-ink text-white" data-id="element-3" data-mp="4n4bxqxqh8g">
          <Header data-id="element-4" data-mp="2zlv6ktmtuzuj" />
          <main className="flex-1 pb-20" data-id="element-5" data-mp="2zmepackaxs9m">
            <Routes data-id="element-6" data-mp="2zng2onosiqui">
              <Route path="/" element={<Home data-id="element-8" data-mp="33nq6put0v76q" />} data-id="element-7" data-mp="33mf623uvifju" />
              <Route path="/catalogo" element={<Catalog data-id="element-10" data-mp="38lro8basuyg3" />} data-id="element-9" data-mp="33mym1f0yqtv8" />
              <Route path="/vehiculo/:id" element={<VehicleDetail data-id="element-12" data-mp="38kgl8dp6huq1" />} data-id="element-11" data-mp="38li8dgjgy7o4" />
              <Route path="/simulador" element={<Simulator data-id="element-14" data-mp="3dlw727z6k59h" />} data-id="element-13" data-mp="3dkuw03i5zirr" />
              <Route path="/chequeo" element={<CreditCheck data-id="element-16" data-mp="nvj2rdpwcaoo" />} data-id="element-15" data-mp="3dm5xtxs1ugg8" />
              <Route path="/comparar" element={<Compare data-id="element-18" data-mp="nvaq9mxor7e0" />} data-id="element-17" data-mp="nwc5m3lqig1j" />
              <Route path="/marcas" element={<Brands data-id="element-20" data-mp="stuexv3nyxa2" />} data-id="element-19" data-mp="sunby4ctm8f0" />
              <Route path="/marcas/:slug" element={<BrandDetail data-id="element-22" data-mp="swghthfm0oly" />} data-id="element-21" data-mp="st2h0dmlgngm" />
              <Route path="/admin" element={<Admin data-id="element-24" data-mp="34x13f0jn52b" />} data-id="element-23" data-mp="35ozexlizgwa" />
              <Route path="*" element={<Home data-id="element-26" data-mp="3ud1ff9ao9oam" />} data-id="element-25" data-mp="38b5essrpoce" />
            </Routes>
          </main>
          <Footer data-id="element-27" data-mp="3ucj91juaptoz" />
          <CompareBar data-id="element-28" data-mp="3uf5lnxw1mze2" />
          <VirtualAssistant data-id="element-29" data-mp="d57f31uekgij" />
        </div>
        <Toaster theme="dark" position="top-center" richColors data-id="element-30" data-mp="d45vg8zbmlp7" />
      </BrowserRouter>
    </StoreProvider>;
}